
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';
import { clientQuery } from 'Core/data/GraphQLApi';
//```import constants types
import {
    VIDFLEET_MAINTENANCE_WARNINGS_REQUEST
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';

import {
    maintenaceWarningResult
} from 'Redux/actions';

function* maintenanceWarning({ payload }) {
    try {
        const { filters } = payload;
        let startDate = filters.startDate
        let endDate = filters.endDate
        let count = +filters.limit;
        let from = +filters.from;
        let hasMore = filters.hasMore;

        let QUERY_MAINTENANCE_WARNINGS = `
            query getMaintenanceWarnings($esn: String, $from: Int!, $count: Int!, $dateRange: AWSDateTimeRange){
                result: getMaintenanceWarnings(esn: $esn, from: $from, count: $count, dateRange: $dateRange)
            }
        `

        let dateRange = null

        if(filters?.filterByDate){
            dateRange = {
                start: startDate,
                end: endDate
            }
        }

        let dataMaintenance = yield call(
            clientQuery,
            QUERY_MAINTENANCE_WARNINGS,
            {
                esn: filters.esn || null,
                from: from,
                count: count,
                dateRange: dateRange
            },
            endpoints.GRAPHQL_GENERAL,
        );

        let result = {}

        if (dataMaintenance.result) {
            result = JSON.parse(dataMaintenance.result)
            if (result?.maintenanceWarnings?.length > 0) {
                let serials = result?.maintenanceWarnings.map(x => x.cameraSN)
                const QUERY_UNITS = `
                    query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                        result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                            items {
                                id
                                esn
                                deviceModel {
                                    name
                                }
                                company {
                                    id
                                    name
                                }
                                linkedUnit {
                                    id
                                    label
                                    esn
                                }
                                linkedMode
                            }
                            total
                        }
                    }
                `;

                let data = yield call(
                    clientQuery,
                    QUERY_UNITS,
                    {
                        conditions: {
                            fields: ["esn"],
                            terms: serials,
                            exact: true
                        },
                        limit: result?.maintenanceWarnings?.length,
                        offset: 0
                    },
                    endpoints.GRAPHQL_GENERAL,
                );
                let devicesInfo = data?.result?.items || []
                result.maintenanceWarnings = result.maintenanceWarnings.map((device) => {
                    device.adicionalInfo = devicesInfo.find(x => x.cameraSN === device.esn)
                    return device
                })
            }
        }

        yield put(maintenaceWarningResult({ result, error: null, hasMore }));

    } catch (exc) {
        yield put(maintenaceWarningResult({ error: true, errorCode: exc.request?.status }));
        ExceptionManager(
            exc,
            "",
            "maintenanceWarningList"
        )
    }
}


function* watchMethods() {
    yield takeEvery(VIDFLEET_MAINTENANCE_WARNINGS_REQUEST, maintenanceWarning);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}